import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import SelectField from '../../shared/form-elements/select/field';

const Form = ({
	handleSubmit,
	submitForm,
	editId,
	intl,
	can,
	loadAffiliatesLookup,
	loadGeosLookup,
	loadOffersLookup
}) => (
	<div className="form-container cpl-rule-form">
		<div className="form-container__head">
			<h2>{ intl(editId ? 'Edit rule' : 'Create new rule') }</h2>
		</div>

		<div className="form-container__body">
			<form className="ui-form create-cpl-rule" onSubmit={handleSubmit(data => submitForm(data, editId))}>

				<div className="ui-form__element">
					<Field
						name="offer_id"
						searchable={true}
						placeholder={intl('Offer')}
						multi={false}
						component={SelectField}
						options={loadOffersLookup}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="geo_id"
						searchable={true}
						placeholder={intl('Geo')}
						multi={false}
						component={SelectField}
						options={loadGeosLookup}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="affiliate_id"
						searchable={true}
						placeholder={intl('Affiliate')}
						multi={false}
						component={SelectField}
						options={loadAffiliatesLookup}
					/>
				</div>

				<div className="ui-form__element buttons">
					{can('cplRulesEdit') &&
						<button className="ui-btn ui-btn-primary">
							{intl(!editId ? 'Save' : 'Edit')}
						</button>}
					{<Link to="cpl-rules/">
						<button type="button" className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>}
				</div>
			</form>
		</div>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func,
	can: PropTypes.func,
	loadOffersLookup: PropTypes.func,
	loadAffiliatesLookup: PropTypes.func
};

const validate = () => {
	const errors = {};
	return errors;
};

export default reduxForm({
	form: 'cplRulesForm',
	validate
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/cpl-rules/components/form.js